// removed by extract-text-webpack-plugin
module.exports = {"CheckboxLabel":"_3jDxFaghzW3rCI8SXyyRcZ","Checkbox":"_1r5QaGkelm5sJeEVE05R5T","Checkmark":"_18QJhz7caOEfWaai_dKKOi","CheckmarkOff":"_3FxxAMS1HjSsVQoUl8pj1M","CheckmarkOn":"_11cCyP4s3j6XMztBE6_dlb","CheckmarkOnDisabled":"DmbY7UERAl8CFom9oeAZb","fullWidth":"QNb5gBhMfFnMuF9JugbmH","error":"_2ENEcVXZ4LdDQqy0LCD02-","ErrorText":"_2v46QEYYi-6F7f1xMW2epu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/index.css
// module id = 878
// module chunks = 0